import { Link } from "react-router-dom";
import { ClipboardList, ChevronRight, CheckCircle2, Loader2, GraduationCap, CalendarDays } from "lucide-react";
import { useExaminerMyCourseAssignmentsQuery } from "../../api/examsApi";

export default function ExaminerMyMarkingPage() {
  const { data: rows = [], isLoading } = useExaminerMyCourseAssignmentsQuery();

  return (
    <div className="min-h-screen bg-[#F7F8FA] px-4 sm:px-6 lg:px-10 py-6 sm:py-10">
      <div className="max-w-4xl mx-auto">
        <header className="mb-6 flex items-center gap-3">
          <div className="p-2.5 rounded-2xl bg-indigo-50 border border-indigo-100"><ClipboardList className="w-5 h-5 text-indigo-600" /></div>
          <div>
            <h1 className="text-2xl font-black text-slate-900">My Marking</h1>
            <p className="text-sm text-slate-500">
              Courses and interview panels the Chief Examiner assigned you to mark.
            </p>
          </div>
        </header>

        {isLoading && <div className="py-16 flex justify-center text-slate-400"><Loader2 className="w-6 h-6 animate-spin" /></div>}

        {!isLoading && rows.length === 0 && (
          <div className="bg-white border rounded-2xl p-10 text-center text-slate-500">
            You have not been assigned anything to mark yet.
          </div>
        )}

        <div className="space-y-3">
          {(rows as any[]).map((r) => {
            const total = r.candidate_count || 0;
            const marked = r.marked_count || 0;
            const pct = total > 0 ? Math.round((marked / total) * 100) : 0;
            const done = total > 0 && marked >= total;

            return (
              <Link
                key={r.assignment_id}
                to={`/exams/examiner/mark/${r.exam_diet_id}/${r.course_id}`}
                className="block bg-white border border-slate-100 rounded-2xl p-4 sm:p-5 hover:border-indigo-200 hover:shadow-sm transition group"
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="flex flex-wrap items-center gap-2 mb-1.5">
                      {r.exam_title && (
                        <span className="inline-flex items-center gap-1 text-[10px] font-bold text-indigo-700 bg-indigo-50 border border-indigo-100 rounded-md px-2 py-0.5">
                          <GraduationCap size={11} /> {r.exam_code || r.exam_title}
                        </span>
                      )}
                      {r.diet_title && (
                        <span className="inline-flex items-center gap-1 text-[10px] font-bold text-slate-500 bg-slate-100 rounded-md px-2 py-0.5">
                          <CalendarDays size={11} /> {r.diet_title}
                        </span>
                      )}
                    </div>
                    <div className="font-black text-slate-900 text-sm sm:text-base truncate">
                      {r.course_code ? <span className="text-indigo-600">{r.course_code}</span> : null}
                      {r.course_code ? " — " : ""}{r.course_name}
                    </div>
                  </div>
                  <div className="flex items-center gap-2 shrink-0">
                    {done && <CheckCircle2 size={18} className="text-emerald-500" />}
                    <ChevronRight size={18} className="text-slate-300 group-hover:text-indigo-400" />
                  </div>
                </div>

                {/* progress */}
                <div className="mt-3">
                  <div className="flex items-center justify-between text-[11px] font-bold text-slate-400 mb-1">
                    <span>Marked {marked} / {total}</span>
                    <span className={done ? "text-emerald-600" : ""}>{pct}%</span>
                  </div>
                  <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
                    <div className={`h-full rounded-full transition-all duration-500 ${done ? "bg-emerald-400" : "bg-indigo-500"}`} style={{ width: `${pct}%` }} />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
